import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import {
  SectionConfigDto,
  CreateSectionConfigDto,
  UpdateSectionConfigDto,
} from '@anessa/shared-models';
import { IdValidation } from '../../shared/interfaces/id-validation.interface';

const BASE = '/api/section-configs';

@Injectable({ providedIn: 'root' })
export class SectionConfigApiService implements IdValidation {
  private readonly http = inject(HttpClient);

  isValidId(id: string): Observable<boolean> {
    return this.getAll().pipe(map((sections) => sections.some((section) => section.key === id)));
  }

  getAll(): Observable<SectionConfigDto[]> {
    return this.http.get<SectionConfigDto[]>(BASE);
  }

  create(dto: CreateSectionConfigDto): Observable<SectionConfigDto> {
    return this.http.post<SectionConfigDto>(BASE, dto);
  }

  update(id: string, dto: UpdateSectionConfigDto): Observable<SectionConfigDto> {
    return this.http.patch<SectionConfigDto>(`${BASE}/${id}`, dto);
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`${BASE}/${id}`);
  }
}
